<template >
    <v-flex >
                <v-card tile>
                <v-toolbar card dark color="primary">
                    <v-btn icon @click.native="closeDialog()" dark>
                    <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Create {{appTitle}} Account</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-flex xs10 mx-auto>
                        <div class="text-xs-center">     
                            <div class="headline mt-4">Create a {{appTitle}} Account</div>   
                            <div class="text-xs-left mt-4 mb-2">All fields are required.</div>  
                            <v-text-field
                                v-model="vemail"
                                label="Email" ></v-text-field>                    
                            <v-text-field
                                v-model="vusername"
                                label="Username"></v-text-field>
                                                              
                            <v-text-field
                                v-model="vpassword"
                                label="Password"
                                :type="'password'"></v-text-field> 
                            <v-select
                                label="What are your Goals?"
                                :items="GoalsDefaults"
                                v-model="vgoals"
                                multiple
                                chips
                                hint=""
                                persistent-hint
                            ></v-select>       
                            <v-select
                                label="What do you sing?"
                                :items="SingerTypeDefaults"
                                v-model="vsingerType"
                                multiple
                                chips
                                hint=""
                                persistent-hint
                            ></v-select> 
                            <v-select
                                label="Gender?"
                                :items="GenderDefaults"
                                v-model="vgenderType"
                                multiple
                                chips
                                hint=""
                                persistent-hint
                            ></v-select> 
                            <v-select
                                label="Age?"
                                :items="AgeDefaults"
                                v-model="vage"
                                multiple
                                chips
                                hint=""
                                persistent-hint
                            ></v-select> 
                            <v-select
                                label="Voice Type?"
                                :items="VoiceTypeDefaults"
                                v-model="vvoiceType"
                                multiple
                                chips
                                hint=""
                                persistent-hint
                            ></v-select> 
                            <v-select
                                label="Voice Descriptives?"
                                :items="VoiceDescriptivesDefaults"
                                v-model="vvoiceDescriptive"
                                multiple
                                chips
                                hint=""
                                persistent-hint
                            ></v-select>                                                                                                                                                          
                            <v-btn round color="primary" dark  v-on:click.native="createAccount(vusername, vemail, vpassword, vvoiceDescriptive, vage, vgenderType, vvoiceType, vgoals, vsingerType)">Create Account</v-btn>
                            <v-btn round color="primary" dark  @click.native="closeDialog()" >Back to Login</v-btn>
                            
                        </div>
                    </v-flex>
                </v-card-text>
                </v-card>        
        </v-flex>
</template>

<script>

import LoginService from './LoginService.js'
import AppConst from './AppConst.js'
import CreateUserMutation from './mutations/CreateUserMutation'
import ListUsersQuery from './queries/ListUsersQuery';


var appTitleLocal = AppConst.appTitle;

export default {
  data () {
    return {
      vusername:'',
      vpassword: '',
      vemail: '',
      vvoiceDescriptive: '',
      vage: '',
      vgenderType: '',
      vvoiceType: '',
      vgoals: '',
      vsingerType: '',
      msg: 'Login',
      session: '',
      startSessionValid: '',
      dialog: true,
      appTitle: appTitleLocal,
      VoiceTypeDefaults: AppConst.registerVoiceTypeDefaults,
      AgeDefaults: AppConst.registerAgeDefaults,
      GenderDefaults: AppConst.registerGenderDefaults,
      SingerTypeDefaults: AppConst.registerSingerTypeDefaults,
      GoalsDefaults: AppConst.registerGoalsDefaults,
      VoiceDescriptivesDefaults: AppConst.registerVoiceDescriptivesDefaults, 
      CreateUserMutation: CreateUserMutation, 
      ListUsersQuery: ListUsersQuery,
    }
  },
  mounted(that=this){
      console.log("mounted created user");
        LoginService.getSession(that, function(data){ 
            that.startSessionValid=data; 
            that.session=data;
            console.log("Session is:"+data);
        });
  },
  methods: {
        closeDialog: function(){ 
        this.$parent.$parent.dialog=false;
        } ,
        getSession: function(){
          
          LoginService.getSession(this, function(data){ return data; })
          
        },
        createAccount: function(vusername, vemail, vpassword, vvoiceDescriptive, vage, vgenderType, vvoiceType, vgoals, vsingerType){
            /* store these locally */
            localStorage.username=vusername;
            localStorage.email=vemail;
            localStorage.voiceDescriptive = vvoiceDescriptive;
            localStorage.age = vage;
            localStorage.genderType = vgenderType;
            localStorage.voiceType = vvoiceType;
            localStorage.goals = vgoals;          
            localStorage.singerType = vsingerType;
  
            var that=this;
            LoginService.registerUser(vusername, vemail, vpassword, ()=>{ 
                that.$apollo.mutate({
                    variables: {
                        input: {
                            id: localStorage.subID,
                            username: localStorage.username,
                            email: localStorage.email,
                            goals:  localStorage.goals,
                            voicePursuit:  localStorage.singerType,  
                            gender: localStorage.genderType,
                            Age:    localStorage.age, 
                            voiceType: localStorage.voiceType,    
                            voiceDescriptives: localStorage.voiceDescriptive,                        
                        }
                    },
                    mutation: CreateUserMutation
                }).then(function() {
                    //close dialog
                    that.dialog = false;
                    //post confirmation message

                }).catch(
                    error => console.error(error)
                    
                );

            } );
        }
  }
  
}


</script>








// WEBPACK FOOTER //
// src/components/CreateUser.vue